import { render, staticRenderFns } from "./StampRallyShow.vue?vue&type=template&id=83a8d1b8&"
import script from "./StampRallyShow.vue?vue&type=script&lang=ts&"
export * from "./StampRallyShow.vue?vue&type=script&lang=ts&"
import style0 from "./StampRallyShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports